<div class="inn-explanation-container" [ngClass]="{ 'invisible' : !isExistingInnName }">
  <div class="inn-explanation-info inn-explanation-info-text">
    US firms that have a US IND number are expected to file for a USAN first, rather than requesting a nonproprietary
    name directly from the INN Programme. If you are requesting a name that is already an INN, please list INN number
    and explain why the INN submission was made first, and include the INN number and documentation showing the INN
    Experts selected this name.
  </div>
  <div class="inn-explanation-item-container">
    <div class="inn-explanation-item-input-container">
      <mat-form-field appearance="outline" class="inn-explanation-form-field">
        <mat-label>WHO/INN Submission Number</mat-label>
        <input matInput #innSubmissionNumberInput [(ngModel)]="innSubmissionNumber" 
          class="inn-explanation inn-explanation-item-input" (keyup.enter)="updateInnSubmissionNumber($event)" 
          (keyup.escape)="cancelSubmissionNumberUpdate()" (blur)="updateInnSubmissionNumber($event)" />
        <mat-icon matSuffix class="inn-explanation-trailing-icon"
          (mousedown)="clearInnSubmissionNumberInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('innSubmissionNumber', 'required')">
      This is a required field.
    </div>
  </div>
  <!-- Explanation field -->
   <div class="inn-explanation-item-container">
    <div class="inn-explanation-item-input-container">
      <mat-form-field appearance="outline" class="inn-explanation-form-field">
        <mat-label>Explanation</mat-label>
        <textarea matInput #innExplanationInput [(ngModel)]="innExplanation" rows="3" 
          class="inn-explanation inn-explanation-item-input" (keyup.enter)="updateInnExplanation($event)" 
          (keyup.escape)="cancelInnExplanationUpdate()" (blur)="updateInnExplanation($event)"></textarea>
        <mat-icon matSuffix class="inn-explanation-trailing-icon"
          (mousedown)="clearInnExplanationInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('innExplanation', 'required')">
      This is a required field.
    </div>
  </div>
</div>